import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@Assets/Fonts/moniqa-display-wakamaifondue.css';

import AppPC from './App_PC';
import AppMO from './App_MO';
import ua from '@Utils/GetUserAgent';

import reportWebVitals from './reportWebVitals';
//import '@ant-design/pro-components/dist/components';

const App = () => {
  // document.body.addEventListener('touchmove', (e) => {
  //   e.preventDefault();
  // }, { passive: false });
  if (ua.android || ua.ios) {
    return <AppMO />
  } else {
    return <AppPC />
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
